import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { get } from 'lodash';
import { useHistory } from 'react-router-dom';

import { freeTialElements } from '../../utilities/constants';
import RenderField from '../../components/RenderField';
import { trialSignupRequest, trackEvent as trackEventAction } from '../../store/signup/signupAction';
import Header from '../../components/Header';
import Captcha from '../../components/Captcha';
import { required } from '../../utilities/validations';
import ReduxPhone from '../../components/ReduxPhone';
import SharpSpringScriptLoader from './SharpSpringScriptLoader';

/**
 * Free trial signup component
 * @param {*} props
 */
const FreeTrial = (props) => {
    const history = useHistory();

    const { handleSubmit, trialSignupRequest, trackEvent } = props;
    const [loader, setLoader] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    /**
     * save trial form data
     * @param {*} data
     */
    const saveTrialData = (data) => {
        setLoader(true);
        return trialSignupRequest(data).then((res) => {
            if (res.status === 'success') {
                if (
                    get(res, 'message') ===
                    'This email is already registered.'
                ) {
                    setLoader(false);
                    throw new SubmissionError({
                        businessEmail: 'This email is already registered.',
                        _error: 'Signup failed',
                    });
                } else if (get(res, 'message') === 'Domain is not allowed.') {
                    setLoader(false);
                    throw new SubmissionError({
                        businessEmail: 'Please use your business domain.',
                        _error: 'Signup failed',
                    });
                }
                trackEvent(process.env.REACT_APP_TRACKER_TRIAL_SIGNUP_ENDPOINT_ID, {
                    email: get(data, 'businessEmail'),
                    companyName: get(data, 'companyName'),
                    firstName: get(data, 'firstName'),
                    lastName: get(data, 'lastName'),
                    phone: get(data, 'phone'),
                    formId: get(res, 'data.form_id'),
                });
                history.push('/trial-verification');
            } else {
                setErrorMessage(res.message);
            }
            setLoader(false);
        });
    };

    return (
        <>
            <div className="container">
                <Header />                
                <SharpSpringScriptLoader/>
                {loader && <div className="loader"></div>}
                <div className="content signup">
                    <div className="content-block-right">
                        <div className="sec-header-block">
                            <h1>Sign up for a 30 Day Free Trial</h1>
                            <p>
                                Share your business contact details to help us
                                set up your InfinCE Account.
                            </p>
                        </div>
                        <form onSubmit={handleSubmit(saveTrialData)}>
                            <span className="error-message">
                                {errorMessage}
                            </span>
                            <div className="form-block">
                                {freeTialElements.map((element, index) => {
                                    return (
                                        <div key={index} className="row">
                                            {element.rowData.map((formElem) => {
                                                return (
                                                    <div
                                                        key={formElem.id}
                                                        className="form-group col-2"
                                                    >
                                                        {formElem.name ===
                                                        'phone' ? (
                                                            <Field
                                                                name={
                                                                    formElem.name
                                                                }
                                                                component={
                                                                    ReduxPhone
                                                                }
                                                                placeholder={
                                                                    formElem.placeholder
                                                                }
                                                                validate={
                                                                    formElem.validators
                                                                }
                                                                onChange={() =>
                                                                    setErrorMessage(
                                                                        null
                                                                    )
                                                                }
                                                                normalize={get(
                                                                    formElem,
                                                                    'normalize'
                                                                )}
                                                                format={get(
                                                                    formElem,
                                                                    'formattor'
                                                                )}
                                                            />
                                                        ) : (
                                                            <Field
                                                                name={
                                                                    formElem.name
                                                                }
                                                                component={
                                                                    RenderField
                                                                }
                                                                type={
                                                                    formElem.type
                                                                }
                                                                className="form-control"
                                                                placeholder={
                                                                    formElem.placeholder
                                                                }
                                                                validate={
                                                                    formElem.validators
                                                                }
                                                                format={get(
                                                                    formElem,
                                                                    'formattor'
                                                                )}
                                                                normalize={get(
                                                                    formElem,
                                                                    'normalize'
                                                                )}
                                                                onChange={() =>
                                                                    setErrorMessage(
                                                                        null
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    );
                                })}
                                <div className="row">
                                    <div className="form-group col-2">
                                        <Field
                                            name="captcharesponse"
                                            component={Captcha}
                                            validate={required}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group">
                                    <span className="form-warning-text">
                                        * Please note that your trial instance
                                        can be set up only with a valid business
                                        domain email. Due to a rise in spam
                                        requests, our executives may need to
                                        contact you for validating your
                                        specified email address.
                                    </span>
                                </div>
                            </div>
                            <div className="form-block align-right mt-30">
                                <button className="btn-primary">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapDispatchToProps = {
    trialSignupRequest,
    trackEvent: trackEventAction
};
const mapStateToProps = (store, props) => ({
    needDomain: get(store, 'signupReducer.needDomain', null),
    stateList: get(store, 'signupReducer.stateData.states', []),
    initialValues: props.initialValues,
    onSubmit: props.submit,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    reduxForm({
        form: 'trialSignUp', // a unique identifier for this form
    })(FreeTrial)
);
